import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const InventoryTrackingBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-black px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image6}
            alt="Inventory Management"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter
            Care
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">
                Common Inventory Management Issues in Hospitals
              </h2>
              <ul className="list-disc list-inside">
                <li>Stockouts during critical procedures or emergencies</li>
                <li>Overstocking leading to expired or unused medicines</li>
                <li>Lack of visibility across departments or branches</li>
                <li>Manual entry errors and delay in stock updates</li>
                <li>No proactive alerts for low stock or nearing expiry</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                MedOps AI-Driven Inventory Tracking Solution
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  <strong>Real-Time Visibility:</strong> Track medicines and
                  equipment across all branches in one dashboard
                </li>
                <li>
                  <strong>Expiry & Low Stock Alerts:</strong> Automated
                  notifications prevent wastage and shortages
                </li>
                <li>
                  <strong>AI Forecasting:</strong> Predict future demand based
                  on usage patterns and seasonal trends
                </li>
                <li>
                  <strong>Central Pharmacy Integration:</strong> Unified
                  management for procurement, dispatch, and delivery
                </li>
                <li>
                  <strong>Barcode & RFID Ready:</strong> Easy scanning for fast
                  and accurate stock updates
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                Results That Matter
              </h2>
              <ul className="list-disc list-inside">
                <li>Up to 60% reduction in medicine wastage</li>
                <li>
                  Improved emergency readiness through availability assurance
                </li>
                <li>
                  Centralized control across multi-location hospital chains
                </li>
                <li>Streamlined audit and compliance reporting</li>
                <li>
                  Better care delivery through uninterrupted access to supplies
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              to: "/inpatientoutpatientblog",
              alt: "IP & OP Automation",
              title:
                "Explore how MedOps integrates with ABHA IDs, digital health missions, and AI automation to build the future of Indian healthcare",
              image: image2,
            },
            {
              to: "/voiceprescriptionblog",
              alt: "Voice Prescription",
              title:
                "Learn how MedOps uses AI for real-time monitoring, cloud-based records, and decision support to enhance patient care",
              image: image1,
            },
            {
              to: "/hospitalpharmacyintegrationblog",
              alt: "Pharmacy Integration",
              title:
                "Discover how AI-powered hospital management systems like MedOps reduce paperwork, improve staff efficiency, and enable data-driven decisions",
              image: image5,
            },
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },
            {
              to: "/diagnosticlabintegrationblog",
              alt: "Diagnostic & Lab",
              title:
                "AI-Powered Diagnostic Report Generation & Lab Integration",
              image: image4,
            },
            {
              to: "/advancedanalyticscampaignblog",
              alt: "Analytics & Campaigns",
              title: "Advanced Analytics & Campaign Management",
              image: image3,
            },
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
                 {
                                      image: image204,
                                      alt: "MedicineForecastingBlog",
                                      to: "/medicineforecastingblog",
                                      title: " Learn more about Medicine Forecasting ",
                                    },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InventoryTrackingBlog;
